import { WorkerAction, WorkerActionError, WorkerFnParams } from '../wasm-git.worker.model';
import type { GitAction } from './actions.enum';

export interface GitStatusAheadBehindAction extends WorkerAction {
  type: GitAction.StatusAheadBehind;
}

export class GitStatusAheadBehindActionError extends WorkerActionError {}

export async function GitStatusAheadBehindActionFn({
  lg,
}: WorkerFnParams<GitStatusAheadBehindAction>): Promise<{ ahead: number; behind: number }> {
  try {
    const status = lg.callAndCaptureOutput(['status']);
    const aheadBehind = (status.split('\n')[1] || '').split(',');
    const aheadStr = aheadBehind[0] || '';
    const behindStr = aheadBehind[1] || '';
    const ahead = Number.parseInt(aheadStr.replace('Your branch is ahead by ', '').replace('#', '').trim()) || 0;
    const behind =
      Number.parseInt(behindStr.replace('behind by ', '').replace('#', '').replace('commits.', '').trim()) || 0;

    return { ahead, behind };
  } catch (err) {
    throw new GitStatusAheadBehindActionError(err);
  }
}
